import styled from "styled-components";

const CTASection = styled.section`
    width: 100%;
`;

const CircleBG = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    background-color: #23A14B;
    opacity: 0;
    border-radius: 100%;
    height: 50rem;
    width: 60rem;

    @media (min-width: 768px) { 
        opacity: 11%;
    }
`;

const CTATitle = styled.h2`
    font-size: 1.7rem!important;
`;

const S = {
  CTASection,
  CircleBG,
  CTATitle
};

export default S;
